import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const { loading } = useSelector((state) => state.admin);
  const token = localStorage.getItem('authToken');

  if (loading) {
    return <div>Loading...</div>; // You can replace this with a proper loading component
  }

  if (!token) {
    return <Navigate to="/admin/login" />;
  }

  return children;
};

export default ProtectedRoute; 